// ── Month-calendar responsive helpers ─────────────────────────────────────
// Pure functions driven by the calendar container's measured width (via a
// ResizeObserver in the page component). Kept out of index.tsx so they can
// be unit-tested without pulling in the whole page module.
//
// Buckets (per user spec):
//   <900px  → compact : 2 visible events/cell, 2-line MonthEventCard
//   900-1199 → medium : 3 visible events/cell, 3-line MonthEventCard
//   ≥1200   → full   : 4 visible events/cell, 4-line MonthEventCard
//
// The upper "large desktop" bucket lifts the visible cap to 4 so wide screens
// can show more without triggering "+N more" prematurely.

import type { MonthEventDensity } from "./MonthEventCard";

export interface MonthCellLimits {
  density: MonthEventDensity;
  maxEventsPerCell: number;
}

export const getMonthCellLimits = (containerWidth: number): MonthCellLimits => {
  if (!Number.isFinite(containerWidth) || containerWidth <= 0) {
    // Server-side / first paint before measurement: assume the desktop path
    // so hydration mirrors what a wide viewport will resolve to.
    return { density: "full", maxEventsPerCell: 4 };
  }
  if (containerWidth < 900) return { density: "compact", maxEventsPerCell: 2 };
  if (containerWidth < 1200) return { density: "medium", maxEventsPerCell: 3 };
  return { density: "full", maxEventsPerCell: 4 };
};
